import { put } from 'redux-saga/effects'

import { StorageActions } from '../actions'

export function* init({
  payload: { id },
}: ReturnType<typeof StorageActions.init>) {
  yield put(StorageActions.setStorage({ id }))
  yield put(StorageActions.setAttachments({ id }))
}
